export default __webpack_public_path__ + "static/media/F0004.f3c2f898.png";